import React, { useEffect } from 'react';
import GoogleLogin from 'react-google-login';
    import { gapi } from 'gapi-script';
import Google from 'assets/images/google.svg';
import { Button, Avatar, Typography } from '@material-ui/core';

const GoogleAuth = ({ onLoginSuccess, onLoginError }) => {
    const clientOAuth = '474884879866-404nd37vojdrc4csaa84rvs66p9h9bbb.apps.googleusercontent.com';
    useEffect(() => {
        const start = () => {
            gapi.auth2.init({
                client_id: clientOAuth
            });
        };
        gapi.load('client:auth2', start);
    }, []);

    const handleLoginSuccess = (user) => {
        // Llama a la función onLoginSuccess si está definida en los props
        if (onLoginSuccess) onLoginSuccess(user?.profileObj);
    };

    // Función para manejar errores de inicio de sesión
    const handleLoginError = (error) => {
        // Llama a la función onLoginError si está definida en los props
        if (onLoginError) onLoginError(error);
    };
    return (
        <GoogleLogin
            clientId={clientOAuth}
            onSuccess={handleLoginSuccess}
            onFailure={handleLoginError}
            render={(renderPros) => (
                <Button
                    fullWidth
                    variant="outlined"
                    style={{ padding: 5, textTransform: 'none' }}
                    startIcon={<Avatar src={Google} style={{ width: 26, height: 26 }} />}
                    onClick={renderPros.onClick}
                >
                    <Typography variant="caption" style={{ fontSize: 14, fontFamily: 'sans-serif', color:'black' }}>
                        Iniciar sesión con Google
                    </Typography>
                </Button>
            )}
        />
    );
};

export default GoogleAuth;
